import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";
import { v_LocationDetailBus } from "./v_LocationDetailBus";

export class InvoicePaymentBus extends BaseBus {
    constructor(data: InvoicePaymentBus = null) {
        super(data);
        if (data != null) {
            this.dateReceived = DateFunctions.getDate(data.dateReceived);
            this.insertDt = DateFunctions.getDate(data.insertDt);
            this.updateDt = DateFunctions.getDate(data.updateDt);
        }
    }
    CID(): any {
        return this.invoicePaymentId;
    }
    setId(id: any) {
        this.invoicePaymentId = id;
    }
    setParentId(id: any) {
        this.invoiceId = id;
    }

    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: v_LocationDetailBus = null) {
        this.dateReceived = new Date(date);
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!DateFunctions.isValidDate(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
        this.dateReceived = DateFunctions.getDateTimeWithUTCOffset(this.dateReceived);
    }
  invoicePaymentId: string;
  invoiceId: string;
  dateReceived: Date;
  receivedById: string;
  amountReceived: number;
  paymentMethodId: string;
  qbid: string;
  qbeditSequenceId: string;
  insertDt: Date;
  insertUserId: string;
  updateDt: Date;
  updateUserId: string;
  memo: string;
    refNumber: string;
    isBulk: boolean;
    isConstruction: boolean;
    notificationChecked: boolean;
}
